import { Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { LEGAL_UPDATED, type LegalSection, PRIVACY, TERMS } from "./texts";

/** Privacy policy and terms (f6-18): public, readable without an account. */
function LegalDocument({ title, intro, sections }: { title: string; intro: string; sections: LegalSection[] }) {
  useEffect(() => {
    document.title = `${title} · Orbis`;
    window.scrollTo(0, 0);
  }, [title]);
  return (
    <div className="legal">
      <header className="legal-top">
        <Link to="/login" aria-label="Orbis">
          <img src="/brand/orbis-logo-negativo.svg" alt="Orbis" />
        </Link>
        <nav aria-label="Documentos">
          <Link to="/privacidad" activeProps={{ "aria-current": "page" }}>
            Privacidad
          </Link>
          <Link to="/terminos" activeProps={{ "aria-current": "page" }}>
            Términos
          </Link>
        </nav>
      </header>
      <main className="legal-card">
        <h1>{title}</h1>
        <p className="legal-updated">Última actualización: {LEGAL_UPDATED}</p>
        <p className="legal-intro">{intro}</p>
        <ol className="legal-index">
          {sections.map((s, i) => (
            <li key={s.title}>
              <a href={`#s${i + 1}`}>{s.title}</a>
            </li>
          ))}
        </ol>
        {sections.map((s, i) => (
          <section key={s.title} id={`s${i + 1}`}>
            <h2>
              {i + 1}. {s.title}
            </h2>
            {s.paragraphs?.map((p) => (
              <p key={p}>{p}</p>
            ))}
            {s.items && (
              <ul>
                {s.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {s.after?.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </section>
        ))}
      </main>
      <footer className="legal-foot">Orbis · orbiscrm.app</footer>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <LegalDocument
      title="Política de privacidad"
      intro="Cada empresa es dueña de sus datos y de los de sus clientes. Aquí explicamos, sin letra pequeña, qué hace Orbis con ellos."
      sections={PRIVACY}
    />
  );
}

export function TermsPage() {
  return (
    <LegalDocument
      title="Términos del servicio"
      intro="Las reglas para usar Orbis: qué ofrecemos, qué esperamos de quienes lo usan y qué pasa con los pagos y los datos."
      sections={TERMS}
    />
  );
}

/** Links under the sign-in card and wherever an account starts. */
export function LegalLinks() {
  return (
    <p className="legal-links">
      <Link to="/privacidad">Privacidad</Link>
      <span aria-hidden="true">·</span>
      <Link to="/terminos">Términos</Link>
    </p>
  );
}
